module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"grove\"-in-pomona-california-d2a36ec3339a9e076f8bbbe0ee8ed3f3.png";